import { Skeleton } from '@heidi/design-system/skeleton';
import { cn } from '@heidi/utils';

import { useSessionPageHost } from '../../host-context';

// The V1 session layout keeps a lighter skeleton fill than the DS default.
export const SplitScreenSkeletonLoader = () => {
  const insetDesign = useSessionPageHost().isInsetDesignEnabled();

  return (
    // need exactly mt-11px due to session header height
    <div
      className={cn(
        'mt-[11px] flex size-full grow flex-col items-start justify-center gap-4 sm:pb-4',
        insetDesign ? 'bg-surface-shell' : 'bg-surface-page'
      )}
    >
      <div className={'flex flex-col items-start gap-3'}>
        <div className={'flex flex-row gap-3'}>
          <Skeleton className="h-5 w-[66px] bg-surface-disabled" />
          <Skeleton className="h-5 w-[66px] bg-surface-disabled" />
        </div>
      </div>
      <div className={'mb-1 flex size-full grow flex-col rounded-md bg-surface p-3'}>
        <div className={'flex w-full flex-row justify-between'}>
          <div className={'flex flex-row gap-1'}>
            <Skeleton className="h-9 w-[116px] bg-surface-disabled" />
            <Skeleton className="h-9 w-[90px] bg-surface-disabled" />
            <Skeleton className="size-9 bg-surface-disabled" />
          </div>
          <Skeleton className="h-9 w-[156px] bg-surface-disabled" />
        </div>
      </div>
    </div>
  );
};
